export default __webpack_public_path__ + "static/container-no-image-c814bcdc2cf9191516564433da53ce3c.png";